import React, { useState } from 'react';
import { Button, Card, Tab } from 'react-bootstrap';

import Tabs from '../../../app/components/Tabs';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { FiscalPrinterLocationSearch } from '../../components/FiscalPrinterLocation/FiscalPrinterLocationSearch';
import { GetFiscalPrinterLocationDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/GetFiscalPrinterLocationDto';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { FiscalPrinterLocationEditor } from '../../components/FiscalPrinterLocation/FiscalPrinterLocationEditor';
import {
  fiscalPrinterLocationData,
  validate,
} from '../../../common/spdCore/contexts/FiscalPrinterLocationContext';
import { CreateUpdateFiscalPrinterLocationDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/CreateUpdateFiscalPrinterLocationDto';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const FiscalPrinterLocationsView: React.FC = () => {
  const spd = useSpdCore();
  const [show, setShow] = useState(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [location, setLocation] = useState<GetFiscalPrinterLocationDto>();

  const handleAdd = () => {
    setShow(true);
    setLocation(undefined);
  };

  const handleClose = () => {
    setShow(false);
    setRefresh(!refresh);
  };

  const addEditLocation = async (
    locationCu: CreateUpdateFiscalPrinterLocationDto,
    id?: string,
  ) => {
    const status = await validate(locationCu);
    if (!status.valid) {
      return { saved: false, errors: status.errors };
    }
    try {
      if (id) {
        await spd.fiscalPrinterLocations.update(id, locationCu);
      } else {
        await spd.fiscalPrinterLocations.create(locationCu);
      }
      setShow(false);
      setRefresh(!refresh);
      return {
        saved: true,
        errors: [],
      };
    } catch (response) {
      return {
        saved: false,
        errors: await responseErrors(response as ResponseError),
      };
    }
  };

  const onRowClick = async (id: string) => {
    const item = await spd.fiscalPrinterLocations.get(id);
    setLocation(item);
    setShow(true);
  };

  return (
    <Card>
      <Tabs
        defaultActiveKey="search"
        id="fiscal-printer-locations"
        className="mb-3"
      >
        <Tab eventKey="search" title="Drukarki - Placówki" className="m-3">
          <FiscalPrinterLocationSearch
            getData={spd.fiscalPrinterLocations.getAllByPortion}
            getCount={spd.fiscalPrinterLocations.getAllCount}
            refresh={refresh}
            onRowClick={onRowClick}
          />
          <Button variant="outline-primary" onClick={handleAdd}>
            Nowa drukarka
          </Button>
          <FiscalPrinterLocationEditor
            id={location?.id}
            location={fiscalPrinterLocationData(location)}
            onCompleted={addEditLocation}
            onDeleted={handleClose}
            show={show}
            handleClose={handleClose}
          />
        </Tab>
      </Tabs>
    </Card>
  );
};
